import {
    FETCHED_STAFF,
    FETCHED_STAFF_MEMBER,
    UPDATED_STAFF_MEMBER,
    DISABLED_STAFF_MEMBER,
    ENABLED_STAFF_MEMBER,
    FETCHED_JOB_TITLES,
    FETCHED_STAFF_SITES,
    FETCHED_STAFF_TITLES,
    FETCHED_STAFF_TEAMS,
    FETCHED_PROJECTS_BY_DESTINATION,
    SELECT_STAFF_TITLE,
    SELECT_JOB_TITLES,
    SELECT_STAFF_NAME,
    SELECT_STAFF_FIRST_NAME,
    SELECT_STAFF_TEAMS,
    SELECT_STAFF_SITES,
    SELECT_STAFF_DESTINATIONS,
    SELECT_STAFF_DESCRIPTION,
    PROJECT_REMOVE_FOR_DESTINATION,
    PROJECT_ADD_FOR_DESTINATION,
    FETCHED_STAFF_TRANSLATIONS,
    FETCHED_STAFF_TRANSLATION,
    CREATED_STAFF_TRANSLATION,
    UPDATED_STAFF_TRANSLATION,
    DELETED_STAFF_TRANSLATION,
    ADD_IMAGE,
    DELETE_IMAGE,
    UPDATE_CROPPED_IMAGE,
    UPDATE_IMAGE_META,
    DELETED_STAFF,
} from './types';
import update from 'immutability-helper';
import shortid from 'shortid';
import _findIndex from 'lodash/findIndex';
import _find from 'lodash/find';
import _filter from 'lodash/filter';
import _concat from 'lodash/concat';
import _sortBy from 'lodash/sortBy';

const INITIAL_STATE = {
    staffMember: {
        title_name: '',
        title_id: '',
        firstname: '',
        name: '',
        description: '',
        image: null,
        products: [],
        jobs: [],
        teams: [],
        sites: [],
    },
    allStaff: [],
    allJobs: [],
    allSites: [],
    allTitles: [],
    allTeams: [],
    allProjectsByDestination: [],
    selectedDestinationId: null,
    staffTranslations: [],
    staffTranslation: {},
    touched: false,
};

export default function(state = INITIAL_STATE, action) {
    switch (action.type) {
        case FETCHED_STAFF:
            return update(state, {
                allStaff: {$set: action.payload.data},
                staffMember: {
                    $set: {
                        title_name: '',
                        title_id: '',
                        firstname: '',
                        name: '',
                        description: '',
                        products: [],
                        jobs: [],
                        teams: [],
                        sites: [],
                    },
                },
                touched: {$set: false},
            });

        case FETCHED_STAFF_MEMBER:
            return update(state, {
                staffMember: {$set: action.staffMember},
            });

        case UPDATED_STAFF_MEMBER:
            return update(state, {
                touched: {$set: action.touched},
            });

        case DELETED_STAFF:
            let allStaffMembers = state.allStaff.filter(
                (item) => item.id !== action.staffMember
            );

            return update(state, {
                allStaff: {$set: allStaffMembers},
            });

        case SELECT_STAFF_TITLE:
            return update(state, {
                staffMember: {
                    title_id: {$set: action.title.id},
                    title_name: {$set: action.title.display_name},
                },
                touched: {$set: action.touched},
            });

        case SELECT_STAFF_SITES:
            return update(state, {
                staffMember: {sites: {$set: action.sites}},
                touched: {$set: action.touched},
            });

        case SELECT_STAFF_DESTINATIONS:
            let selectedDestinationsForApi = [];

            action.destinations.forEach((item) => {
                selectedDestinationsForApi.push({
                    destination_id: item.id,
                    destination_name: item.display_name,
                    projects: item.projects ? item.projects : [],
                });
            });

            return update(state, {
                staffMember: {products: {$set: selectedDestinationsForApi}},
                touched: {$set: action.touched},
            });

        case SELECT_STAFF_TEAMS:
            return update(state, {
                staffMember: {
                    teams: {$set: action.payload.staffTeams},
                },
                touched: {$set: action.payload.touched},
            });

        case SELECT_STAFF_FIRST_NAME:
            return update(state, {
                staffMember: {firstname: {$set: action.firstname}},
                touched: {$set: action.touched},
            });

        case SELECT_STAFF_DESCRIPTION:
            return update(state, {
                staffMember: {description: {$set: action.description}},
                touched: {$set: action.touched},
            });

        case SELECT_STAFF_NAME:
            return update(state, {
                staffMember: {name: {$set: action.name}},
                touched: {$set: action.touched},
            });

        case SELECT_JOB_TITLES:
            return update(state, {
                staffMember: {jobs: {$set: action.jobs}},
                touched: {$set: action.touched},
            });

        case FETCHED_JOB_TITLES:
            let sortedJobs = _sortBy(action.jobs, 'display_name');

            return update(state, {
                allJobs: {$set: sortedJobs},
            });

        case FETCHED_STAFF_SITES:
            let selectedAllSites = _sortBy(action.sites, 'display_name');
            let sortedSites = _sortBy(selectedAllSites, 'display_name');

            if (state.staffMember.sites.length) {
                sortedSites = state.staffMember.sites;
                sortedSites = _sortBy(sortedSites, 'display_name');
            }

            return update(state, {
                allSites: {$set: selectedAllSites},
                staffMember: {sites: {$set: sortedSites}},
            });

        case FETCHED_STAFF_TITLES:
            return update(state, {
                allTitles: {$set: action.titles},
            });

        case FETCHED_STAFF_TEAMS:
            let sortedTeams = _sortBy(action.teams, 'display_name');

            return update(state, {
                allTeams: {$set: sortedTeams},
            });

        case DISABLED_STAFF_MEMBER:
            let indexDisabledStaff = state.allStaff.findIndex(
                (item) => item.id === action.staffId
            );

            return update(state, {
                allStaff: {
                    [indexDisabledStaff]: {$merge: {is_active: false}},
                },
            });

        case ENABLED_STAFF_MEMBER:
            let indexEnabledStaff = state.allStaff.findIndex(
                (item) => item.id === action.staffId
            );

            return update(state, {
                allStaff: {
                    [indexEnabledStaff]: {$merge: {is_active: true}},
                },
            });

        case FETCHED_PROJECTS_BY_DESTINATION:
            let toEditDestinationPosition = _findIndex(
                state.staffMember.products,
                {destination_id: action.payload.destinationId}
            );

            let projectsIds = [];

            action.payload.projects.map((project) => {
                return projectsIds.push({id: project.id});
            });

            if (
                state.staffMember.products[toEditDestinationPosition].projects
                    .length !== 0
            ) {
                if (
                    state.allProjectsByDestination.length !==
                    state.staffMember.products[toEditDestinationPosition]
                        .projects.length
                ) {
                    return update(state, {
                        allProjectsByDestination: {
                            $set: action.payload.projects,
                        },
                        selectedDestinationId: {
                            $set: action.payload.destinationId,
                        },
                        touched: {$set: true},
                    });
                }
            }

            return update(state, {
                allProjectsByDestination: {$set: action.payload.projects},
                staffMember: {
                    products: {
                        [toEditDestinationPosition]: {
                            $merge: {projects: projectsIds},
                        },
                    },
                },
                selectedDestinationId: {$set: action.payload.destinationId},
                touched: {$set: true},
            });

        case PROJECT_REMOVE_FOR_DESTINATION:
            let toEditDestination = _find(state.staffMember.products, {
                destination_id: state.selectedDestinationId,
            });

            let toEditDestinationIndex = _findIndex(
                state.staffMember.products,
                {destination_id: state.selectedDestinationId}
            );

            if (toEditDestination !== undefined) {
                let updatedProjects = _filter(
                    toEditDestination.projects,
                    (elem) => {
                        return elem.id !== action.project;
                    }
                );

                return update(state, {
                    staffMember: {
                        products: {
                            [toEditDestinationIndex]: {
                                $merge: {projects: updatedProjects},
                            },
                        },
                    },
                });
            }

            return state;

        case PROJECT_ADD_FOR_DESTINATION:
            let toAddDestination = _find(state.staffMember.products, {
                destination_id: state.selectedDestinationId,
            });

            let toAddDestinationIndex = _findIndex(state.staffMember.products, {
                destination_id: state.selectedDestinationId,
            });

            if (toAddDestination !== undefined) {
                let addUpdatedProjects = _concat(toAddDestination.projects, {
                    id: action.project,
                });

                return update(state, {
                    staffMember: {
                        products: {
                            [toAddDestinationIndex]: {
                                $merge: {projects: addUpdatedProjects},
                            },
                        },
                    },
                });
            }

            return state;

        case FETCHED_STAFF_TRANSLATIONS:
            return update(state, {
                staffTranslations: {$set: action.staffTranslations},
            });

        case FETCHED_STAFF_TRANSLATION:
            return update(state, {
                staffTranslation: {$set: action.staffTranslation},
            });

        case CREATED_STAFF_TRANSLATION:
            return update(state, {
                staffTranslation: {$set: action.staffTranslation},
                touched: {$set: action.touched},
            });

        case UPDATED_STAFF_TRANSLATION:
            return update(state, {
                staffTranslation: {$set: action.staffTranslation},
                touched: {$set: action.touched},
            });

        case DELETED_STAFF_TRANSLATION:
            let allStaffTranslations = state.staffTranslations.filter(
                (item) => item.id !== action.translationId
            );

            return update(state, {
                staffTranslations: {$set: allStaffTranslations},
            });

        /* STAFF IMAGE */

        case ADD_IMAGE:
            return update(state, {
                staffMember: {
                    image: {
                        $set: {
                            id: shortid.generate(),
                            url: action.payload.preview,
                            preview: action.payload.preview,
                            alt: '',
                            title: '',
                            description: '',
                            link: '',
                            filename: action.payload.name,
                            name: action.payload.name,
                            new: true,
                            deleted: false,
                            imageObject: action.payload,
                            croppedImage: null,
                            croppedImageObject: null,
                        },
                    },
                },
                touched: {$set: action.touched},
            });

        case DELETE_IMAGE:
            return update(state, {
                staffMember: {
                    image: state.staffMember.image.new
                        ? {$set: null}
                        : {$merge: {deleted: true}},
                },
                touched: {$set: action.touched},
            });

        case UPDATE_CROPPED_IMAGE:
            return update(state, {
                staffMember: {
                    image: {
                        $merge: {
                            croppedImage: action.payload.imageUrlBlob,
                            croppedImageObject: action.payload.imageBlobObject,
                        },
                    },
                },
                touched: {$set: action.payload.touched},
            });

        case UPDATE_IMAGE_META:
            return update(state, {
                staffMember: {
                    image: {
                        $merge: {
                            alt: action.imageMeta.alt,
                            title: action.imageMeta.title,
                            description: action.imageMeta.description,
                            link: action.imageMeta.link,
                            filename: action.imageMeta.name,
                            name: action.imageMeta.name,
                        },
                    },
                },
                touched: {$set: action.touched},
            });

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/containers/staff/reducer.js